import React, { useState } from "react";
import { MdOutlineSupportAgent } from "react-icons/md";
import { Link } from "react-router-dom";
import { MdLiveTv } from "react-icons/md";
import { MdOutlineRadio } from "react-icons/md";
import { IoMdMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { FaSearch, FaUserCircle } from "react-icons/fa";

const Navbar = ({ value, onChange, handleKeyPress }) => {
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    setOpen(false);
  };

  return (
    <nav className="bg-gray-800 p-1  border-b border-slate-700 top-0 fixed z-50 w-full ">
      <div className="mx-1  md:mx-3 flex  justify-between items-center">
        <div className="text-white text-xl font-bold">
          <Link to="/" className="flex gap-2 cursor-pointer items-center">
            <img
              src="/isologo.png"
              className="object-contain w-[150px] md:w-[185px] lg:w-[280px] "
              alt="NETMAX Logo"
            />
          </Link>
        </div>

        <div className="hidden lg:flex w-full relative items-center">
          <input
            type="search"
            placeholder="Buscar..."
            value={value}
            onChange={onChange}
            onKeyPress={handleKeyPress}
            className="w-3/4 px-4 py-1.5 mx-auto rounded-full bg-slate-700 "
          />
          <FaSearch className="absolute right-[14%] text-gray-400 cursor-pointer" />
        </div>

        <div className="hidden md:flex space-x-4 mr-2 items-center">
          <Link
            to="/play"
            className="text-gray-300 flex items-center cursor-pointer text-[26px] gap-2 -mt-1 hover:text-white"
          >
            <MdLiveTv />
          </Link>
          <Link
            to="/radio"
            className="text-gray-300 flex cursor-pointer items-center text-[26px] gap-2 -mt-1 hover:text-white"
          >
            <MdOutlineRadio />
          </Link>

          <Link
            to="/login"
            target="_blank"
            className="text-gray-300 flex cursor-pointer items-center text-[26px] gap-2 hover:text-white mx-2"
            onClick={handleLogout}
          >
            <FaUserCircle />
          </Link>
        </div>

        <div className="flex md:hidden">
          {!open ? (
            <button
              className="text-gray-300 flex cursor-pointer items-center text-[26px] gap-2 hover:text-white"
              onClick={() => setOpen(true)}
              type="button"
            >
              <IoMdMenu />
            </button>
          ) : (
            <button
              className="text-white flex items-center cursor-pointer text-[26px] gap-2 hover:text-white absolute top-2 right-3"
              onClick={() => setOpen(false)}
              type="button"
            >
              <IoMdClose />
            </button>
          )}{" "}
          {open && (
            <div className="md:hidden flex flex-col p-2 w-1/2 bg-gray-800 absolute top-14 right-0 z-30">
              <Link
                to="/"
                className="block text-gray-300 cursor-pointer text-xl py-2 hover:text-white"
                onClick={() => setOpen(false)}
              >
                <MdLiveTv className="inline-block mr-2" /> TV
              </Link>
              <Link
                to="/radio"
                className="block text-gray-300 cursor-pointer text-xl py-2 hover:text-white"
                onClick={() => setOpen(false)}
              >
                <MdOutlineRadio className="inline-block mr-2" /> Radio
              </Link>

              <Link
                to="/login"
                target="_blank"
                className="flex text-gray-300 items-center justify-start gap-3  cursor-pointer text-xl py-2 hover:text-white"
                onClick={handleLogout}
              >
                <FaUserCircle /> Login
              </Link>
            </div>
          )}
        </div>
      </div>

      <div className="flex lg:hidden my-2  mx-4 items-center relative">
        <input
          type="search"
          placeholder="Buscar..."
          value={value}
          onChange={onChange}
          onKeyPress={handleKeyPress}
          className="w-full px-4 py-2 rounded-full bg-slate-700 pr-10"
        />
        <FaSearch className="absolute right-4 text-gray-400" />
      </div>
    </nav>
  );
};

export default Navbar;
